import * as types from "./MasterActionType";


const initialState = {
    countersFilter: [],
    busStationList: [],
    placeList: [],
    statesList: [],
    statesTableData: [],
    corporationList: [],
    corporationTableData: [],
    leviesFilterList: [],
    corpLeviesFilterList: [],
    leviesTableData: [],
    concessionFilterList: [],
    concessionTableData: [],
    classTypeList: [],
    placeTableData: {},
    crewList: [],
    depotList: [],
    divisionList: [],
    classTypeMasterList: [],
    vehicleMacList: [],
    groupDiscountList: [],
    clssTypeLevyList: [],
    seasonTypeList: [],
    auditModuleList: [],
    masterCodeList: [],
    cargoCityList: [],
    paymentGatewayList: [],
}
const MasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.COUNTERS_FILTER:
            return {
                ...state,
                countersFilter: [...action.payload]
            }
        case types.BUSSTATION_LIST:
            return {
                ...state,
                busStationList: [...action.payload]
            }
        case types.AUDIT_MODULE_LIST:
            return {
                ...state,
                auditModuleList: [...action.payload]
            }

        case types.PLACE_LIST:
            return {
                ...state,
                placeList: [...action.payload]
            }
        case types.CITY_CARGO_LIST:
            return {
                ...state,
                cargoCityList: [...action.payload]
            }
        case types.STATES_LIST:
            return {
                ...state,
                statesList: action?.payload
            };
        case types.STATES_TBL_DATA:
            return {
                ...state,
                statesTableData: action?.payload
            };
        case types.CORPORATION_LIST:
            return {
                ...state,
                corporationList: action?.payload
            };
        case types.CORPORATION_TBL_DATA:
            return {
                ...state,
                corporationTableData: action?.payload
            };
        case types.LEVIES_LIST_DATA:
            return {
                ...state,
                leviesFilterList: action?.payload
            };
        case types.LEVIES_CORP_LIST_DATA:
            return {
                ...state,
                corpLeviesFilterList: action?.payload
            };
        case types.LEVIES_TBL_DATA:
            return {
                ...state,
                leviesTableData: action?.payload
            };
        case types.CONCESSION_LIST:
            return {
                ...state,
                concessionFilterList: action?.payload
            };
        case types.CONCESSION_TBL_DATA:
            return {
                ...state,
                concessionTableData: action?.payload
            };
        case types.CREW_LIST:
            return {
                ...state,
                crewList: [...action.payload]
            }
        case types.DEPOT_LIST:
            return {
                ...state,
                depotList: [...action.payload]
            }
        case types.DIVISION_LIST:
            return {
                ...state,
                divisionList: [...action.payload]
            }
        case types.CLASS_TYPE_LIST:
            return {
                ...state,
                classTypeList: [...action.payload]
            }
        case types.PLACE_TABLEDATA:
            return {
                ...state,
                placeTableData: action?.payload
            };
        case types.CLASS_TYPE_MASTER_LIST:
            return {
                ...state,
                classTypeMasterList: [...action.payload]
            }
        case types.VEHICLE_MAC:
            return {
                ...state,
                vehicleMacList: action.payload
            }
        case types.GROUP_DISCOUNT_LIST:
            return {
                ...state,
                groupDiscountList: [...action.payload]
            }
        case types.CLASS_TYPE_LEVY_LIST:
            return {
                ...state,
                clssTypeLevyList: [...action.payload]
            }
        case types.SEASON_TYPE_LIST:
            return {
                ...state,
                seasonTypeList: [...action.payload]
            }
        case types.UPDATE_MASTER_CODE_LIST:
            return {
                ...state,
                masterCodeList: [...action.payload]
            }
        case types.PAYMENTGATEWAY_LIST:
            return {
                ...state,
                paymentGatewayList: [...action.payload]
            }

        default:
            return state;
    }
}
export default MasterReducer;